module.exports = __webpack_public_path__ + "img/ZB52_07.569ef05d.jpg";